module.exports = "<div class=\"tablelist-not-enabled-banner\">\n  <div class=\"alert alert-warning\">\n    <p>\n      Your venue is not currently setup on Tablelist. Click the button below to find out how to get setup.\n    </p>\n  </div>\n  <p class=\"center\">\n    <button class=\"btn btn-primary\" ng-click=\"enableTablelistVenue()\" track-event event-action=\"{{ SEGMENT_TRACKING_EVENTS.CLICKED_ENABLE_TABLELIST_BUTTON }}\" event-value=\"{{ 'Interested in Tablelist' }}\">\n      Contact to get setup on Tablelist\n    </button>\n  </p>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/tablelistNotEnabledBanner/template.html
// module id = 1232
// module chunks = 0